class CollapsibleElement extends HTMLElement {
  static pinnedCollapsible = null;

  connectedCallback() {
    this.controller = this.querySelector(':scope > [aria-expanded]');
    if (!this.controller) return;

    this.isPinned = false;
    const hoverable = this.controller.dataset.hoverable;

    if (hoverable) {
      this.isHoverable = true;
      this.controller.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      this.controller.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.controller.addEventListener('click', this.handleClick.bind(this));

      this.controller.addEventListener('touchstart', this.handleMouseEnter.bind(this));
      this.controller.addEventListener('touchend', this.handleMouseLeave.bind(this));

      // Find the content element immediately so we can attach event listeners
      this.findContent();

      if (this.content) {
        // Add event listeners to the content element
        this.content.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        this.content.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      }
    } else {
      this.isHoverable = false;
      this.controller.addEventListener('click', this.toggle.bind(this));
    }
  }

  /**
   * find the content element
   */
  findContent() {
    const id = this.controller.getAttribute('aria-controls');
    this.content = document.getElementById(id);

    // Also look for elements with data-collapsible-content attribute
    if (!this.content) {
      this.content = this.querySelector('[data-collapsible-content]');
    }
  }

  /**
   * Handle mouse enter event
   */
  handleMouseEnter() {
    // Only respond to hover if no collapsible is pinned or this one is pinned
    if (!CollapsibleElement.pinnedCollapsible || CollapsibleElement.pinnedCollapsible === this) {
      this.open();
    }
  }

  /**
   * Handle mouse leave event
   */
  handleMouseLeave() {
    // Only close on mouse leave if not pinned
    if (!this.isPinned) {
      this.close();
    }
  }

  /**
   * Handle click event for hoverable collapsibles
   */
  handleClick(event) {
    event.preventDefault();
    if (this.isPinned) {
      // If already pinned, unpin it
      this.isPinned = false;
      CollapsibleElement.pinnedCollapsible = null;
      this.close();
    } else {
      // If another collapsible was pinned, unpin it
      if (CollapsibleElement.pinnedCollapsible) {
        CollapsibleElement.pinnedCollapsible.isPinned = false;
        CollapsibleElement.pinnedCollapsible.close();
      }

      // Pin this collapsible
      this.isPinned = true;
      CollapsibleElement.pinnedCollapsible = this;
      this.open();
    }
  }

  /**
   * Open the collapsible element
   */
  open() {
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'true');
    this.content.setAttribute('aria-hidden', 'false');
  }

  /**
   * Close the collapsible element
   */
  close() {
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('aria-hidden', 'true');
  }

  /**
   * Toggle the collapsible element
   */
  toggle(event) {
    event.preventDefault();
    const isExpanded = this.controller.getAttribute('aria-expanded') === 'true';
    isExpanded ? this.close() : this.open();
  }
}

customElements.define('collapsible-element', CollapsibleElement);
